module.exports = __webpack_public_path__ + "img/Nueva propuesta P2H 1.0-14 (1).67fe88f5.svg";